/**
 * This code was generated by Builder.io.
 */
import React from "react";
import deleteIcon from "../../assets/icons/delete-icon.svg";
import withdrawCardBg from "../../assets/icons/withdraw-card-bg.svg";
import {
  PaymentMethodObjType,
  getAccountHolderName,
  getDisplayName,
  getSourceAccountId,
} from "@hypexone/uicore";

interface PaymentOptionProps {
  paymentMethod: PaymentMethodObjType;
  onAccountDeleteClick: (account: PaymentMethodObjType) => void;
  onSavedAccountCardClick: (account: PaymentMethodObjType) => void;
  currentSelectedAccount: PaymentMethodObjType;
}

const PaymentOption: React.FC<PaymentOptionProps> = ({
  paymentMethod,
  onAccountDeleteClick,
  onSavedAccountCardClick,
  currentSelectedAccount,
}) => {
  const { id } = paymentMethod;

  const handleDeleteClick = () => onAccountDeleteClick(paymentMethod);
  const onPaymentOptionClick = () => onSavedAccountCardClick(paymentMethod);

  const isSelected = currentSelectedAccount
    ? id === currentSelectedAccount.id
    : false;

  return (
    <div
      onClick={onPaymentOptionClick}
      className={`min-w-60 max-w-60 md:min-w-80 md:max-w-80 h-32 md:h-40 rounded-xl overflow-hidden relative ${
        isSelected ? "bg-sky-400" : "bg-sky-100"
      }  p-2 cursor-pointer`}
    >
      <img
        loading="lazy"
        src={withdrawCardBg}
        alt=""
        className="object-cover absolute inset-0 size-full"
      />
      <div className="relative inset-0 size-full flex flex-col justify-between">
        <div className="flex justify-center">
          <div className="font-semibold">{getDisplayName(paymentMethod)}</div>
        </div>

        <div className="w-full flex justify-center">
          <div className="font-semibold">
            {getSourceAccountId(paymentMethod)}
          </div>
        </div>

        <div className="w-full flex justify-end">
          <div className="font-semibold">
            {getAccountHolderName(paymentMethod)}
          </div>
        </div>

        <img
          onClick={handleDeleteClick}
          loading="lazy"
          src={deleteIcon}
          alt="Bank logo"
          className="object-contain shrink-0 w-6 aspect-square absolute top-0 right-0 cursor-pointer"
        />
      </div>
    </div>
  );
};

export default PaymentOption;
